export default function noop() {}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-geo/src/noop.js
// module id = ../../../../d3-geo/src/noop.js
// module chunks = 4